<template>
  <div class="navbar">

        <Hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container"/>
        <Breadcrumb></Breadcrumb>
        <div class="navbar-r">
          <template v-if="device!=='mobile'">
            <Admindrow></Admindrow>
          </template>
        </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Headseach from '@/components/utils/HeadSeach'
import Admindrow from '@/components/utils/Admindrow'
import Headset from '@/components/utils/Headsetting'
import Headlogout from '@/components/utils/Headlogout'

export default {
  data () {
    return {
      username: ''
    }
  },
  components: {
    Breadcrumb,
    Hamburger,
    Headseach,
    Admindrow,
    Headset,
    Headlogout

  },
  created: function () {
    this.username = sessionStorage.getItem('username')
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'avatar',
      'device'
    ])
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('toggleSideBar')
    },
    logout () {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      })
    }
  }
}
</script>

<style  lang="less" scoped>
.navbar {
  width: 100%;
  height: 50px;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1001;
  background: #fff;
  box-shadow: -10px 15px 5px -15px #ccc;
  .el-row{
    width: 100%;
    height: 100%;
    .el-col{
      height: 100%;
      }
  }
  .navbar-r{
    display: flex;
    flex-direction: row;
    align-items: center;
    position: fixed;
    width: auto;
    top: 0;
    right: 0;;
    height: 50px;
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue